import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const CitizenPortalModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken(
    'colors',
    ['primary.200', 'primary.300', 'primary.400', 'primary.500', 'primary.600', 'primary.700', 'primary.900', 'white']
  )

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const strokenWidthSecondary = '20px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Portal_Cidadão" data-name="Portal Cidadão">
          <g>
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M146.34,220.45S243.2,71.83,446.75,58s236.18,115.2,239.73,140.42c6.15,43.78-48.13,96.73-192.43,159.31-44.23,19.18-71.28,129.94,5.49,221.9s72,136.47,59.91,148.69c-40.63,41-138.13,33.15-239.25-17.15S116.72,574.68,98.42,469.26,121.38,258.28,146.34,220.45Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M678.11,537.64a72.4,72.4,0,0,1-12.55,34.63c-23,33.92-65.32,100.8-103.38,108.78-61.48,12.89-54.78-83.54-72.1-129.46C442.42,425.17,686.27,437.31,678.11,537.64Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M337.76,123.22a59.81,59.81,0,0,1,30.38.26c32.68,8.58,96.3,23.18,112.93,50.6,26.87,44.28-50,65.5-80.93,91.55C314.88,337.35,257.5,144.37,337.76,123.22Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M90,205.18a62.38,62.38,0,0,1,34.86-18.49c59.81-10.17,275.6-38.81,401.73,51.06C680.93,347.75,688.2,411,689,437.33c.64,21.38-13.7,126.67-88.46,180.32s-182,83.12-256.55,85.14c-37.46,1-69.62-5.53-92-17.21C234,676.22,188.65,657,131.3,609.67c-85.39-70.4-69-277.93-58.3-371.73C74.52,224.65,82.12,213.44,90,205.18Z"
              />
              <path
                fill={fillColor600}
                d="M617.63,238.11c-10.12-20.22-29.31-50.72-19.64-73.68,10.55-25,70.94,15.6,90.94,35.54C726.51,237.46,625.93,251.67,617.63,238.11Z"
              />
              <path
                fill={fillColor600}
                d="M717.7,525c-5.66,2.43-11.26-3.69-8.15-9,13.43-22.94,14.52-49.55,16.7-75.95,2.45-29.77,0-49.81,30.15-24.65C803.2,454.44,746.82,512.52,717.7,525Z"
              />
              <path
                fill={fillColor600}
                d="M101.45,692.33a10.3,10.3,0,0,1-11.29-10.88,10.47,10.47,0,0,1,9.49-9.61c5.7-.59,15.53-2.52,16.08,3S107.1,691.77,101.45,692.33Z"
              />
            </g>
          </g>
          <g>
            <path
              strokeWidth={strokenWidth}
              fill={fillBG}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M402.92,618.68a218.6,218.6,0,0,1,0-437.2"
            />
            <path
              strokeWidth={strokenWidth}
              fill={fillBG}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M402.92,181.48a218.6,218.6,0,0,1,0,437.2"
            />
            <path
              strokeWidth={strokenWidthSecondary}
              fill={'none'}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M402.92,183.91c113.36,119.67,113.36,312.67,0,432.34"
            />
            <path
              strokeWidth={strokenWidthSecondary}
              fill={'none'}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M402.92,616.25c-113.36-119.67-113.36-312.67,0-432.34"
            />
            <path
              strokeWidth={strokenWidthSecondary}
              fill={'none'}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M196.71,327.21H609.13"
            />
            <path
              strokeWidth={strokenWidthSecondary}
              fill={'none'}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M196.71,473H609.13"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(CitizenPortalModuleBrand)
